export default "__VITE_ASSET__494ddbc1__"